import React from 'react';
import HelpSupportContent from '../../components/HelpSupportContent';

const HelpSupport = () => <HelpSupportContent roleLabel="Student" />;

export default HelpSupport;
